import importerStore from '@shared/importer/importer-store';
import { FanService } from '@modules/fan/fan-service';
import fanImporterFields from '@modules/fan/fan-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  FanService.import,
  fanImporterFields,
  i18n('entities.fan.importer.fileName'),
  i18n('entities.fan.importer.hint'),
);
